<template>
  <b-modal ref="modal" title="Options for this Order" lazy>
    <p>
      Are you ready to have your patient start their
      Preassessment Questionnaire?
    </p>
    <p>
      <b>Optional</b> fields to pre-complete (the patient can
      edit fields when completing the Questionnaire):
    </p>
    <b-form @submit.prevent="submit">
      <v-form-group label="Patient Height (inches)">
        <b-form-input v-model="height"
                      placeholder="Patient Height (inches)"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners" />
      </v-form-group>

      <v-form-group label="Patient Weight (pounds)">
        <b-form-input v-model="weight"
                      placeholder="Patient Weight (pounds)"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners" />
      </v-form-group>

      <v-form-group label="Patient Waist Circumference (inches)">
        <b-form-input v-model="waist"
                      placeholder="Patient Waist Circumference (inches)"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners" />
      </v-form-group>

      <v-form-group label="Patient Systolic Blood Pressure">
        <b-form-input v-model="systolic"
                      placeholder="Patient Systolic Blood Pressure"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners" />
      </v-form-group>

      <v-form-group label="Patient Diastolic Blood Pressure">
        <b-form-input v-model="diastolic"
                      placeholder="Patient Diastolic Blood Pressure"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners" />
      </v-form-group>

      <v-form-group label="CAC Score">
        <b-form-input v-model="survey.arteryBlockages.lastCacTest.obtainedScore"
                      placeholder="CAC Score"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners" />
      </v-form-group>

      <v-form-group label="Age when CAC Score was measured">
        <b-form-input v-model="survey.arteryBlockages.lastCacTest.doneAtAge"
                      placeholder="Age when CAC Score was measured"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners" />
      </v-form-group>
    </b-form>
    <div class="d-flex justify-content-end mt-3">
      <b-btn variant="success" @click="saveSurvey">Send</b-btn>
    </div>
    <hr />
    <b-form>
      Do you want to cancel this order? This cannot be undone
      <v-form-group>
        <b-checkbox v-model="sendEmailOnCancel">
          Send a cancellation email to the patient
        </b-checkbox>
      </v-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn @click="cancel" variant="outline-secondary">Cancel</b-btn>
      <b-btn variant="success" @click="cancelOrder">Ok</b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  const { mapActions, mapState } = createNamespacedHelpers('survey');

  import reportService from 'services/report-service';

  export default {
    data() {
      return {
        sendEmailOnCancel: false,
        reportToCancelId: null,

        height: null,
        weight: null,
        waist: null,
        systolic: null,
        diastolic: null
      }
    },

    computed: {
      ...mapState(['survey'])
    },

    methods: {
      ...mapActions(['getByReportId', 'update']),

      async beforeShow(id) {
        this.reportToCancelId = id;
        await this.getByReportId(id);

        this.height = this.survey.height ? this.survey.height : null;
        this.weight = this.survey.weight ? this.survey.weight : null;
        this.waist = this.survey.waist ? this.survey.waist : null;
        this.systolic = this.survey.bloodPressure.systolic ? this.survey.bloodPressure.systolic : null;
        this.diastolic = this.survey.bloodPressure.diastolic ? this.survey.bloodPressure.diastolic : null;
      },

      async saveSurvey() {
        this.survey.height = this.height ? this.height :  0;
        this.survey.weight = this.weight ? this.weight : 0;
        this.survey.waist = this.waist ? this.waist : 0;
        this.survey.bloodPressure.systolic = this.systolic ? this.systolic : 0;
        this.survey.bloodPressure.diastolic = this.diastolic ? this.diastolic : 0;

        await this.update();
        this.$root.successToast('Survey saved!');

        this.$emit('success');

        this.$refs.modal.hide();
      },

      async cancelOrder() {
        await reportService.cancel(this.reportToCancelId, this.sendEmailOnCancel);
        this.$root.successToast('Report cancelled!');

        this.$emit('cancel');

        this.$refs.modal.hide();
      },

      async show(args) {
        await this.beforeShow(args);

        this.$refs.modal.show();
      },

      cancel() {
        this.$refs.modal.hide();
      },
    }
  }

</script>